<!-- Header -->
<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<ion-content [scrollY]="false">
  <div class="bonds-info__header">
    <div class="bonds-info__top">
      <h1>
        <div class="bonds-info__flag">
          <img [src]="flagSrc" />
          <ion-icon name="leaf"></ion-icon>
        </div>
        {{ ('STRATEGY.bonds.' + bondId + '.title') | translate }}
      </h1>
    </div>
    <p class="bonds-info__bottom">{{ percentage | number: '1.1-1' }}%</p>
  </div>
  <ion-row>
    <ion-col>
      <p>{{ ('STRATEGY.bonds.' + bondId + '.desc') | translate }}</p>
    </ion-col>
  </ion-row>
</ion-content>
